export const JOB_EXPERIENCE_CATEGORY = 'job';
export const EDUCATION_EXPERIENCE_CATEGORY = 'education';
export const HOBBY_EXPERIENCE_CATEGORY = 'hobby';

export const EXPERIENCE_CATEGORIES = [
  JOB_EXPERIENCE_CATEGORY,
  EDUCATION_EXPERIENCE_CATEGORY,
  HOBBY_EXPERIENCE_CATEGORY,
] as const;

export const CERTIFICATION_EDUCATION_TYPE = 'certification';

export const SKILL_CHOICES = [
  'never',
  'almost_never',
  'sometimes',
  'often',
  'almost_always',
  'always',
] as const;

export const GENDER_OPTIONS = ['female', 'male', 'other', 'undisclosed'] as const;

export const MAX_GUESTS_PER_GROUP_SESSION = 5000;
export const MAX_GUESTS_PER_WEBINAR = 10000;
